[
  {
    "id": "first_death",
    "title": "After the First Death",
    "order": 10,
    "requiresKnowledge": ["died_once"],
    "dialogueId": "spirit_scene_first_death"
  },
  {
    "id": "first_dawnmere_survival",
    "title": "The Morning Dawnmere Held",
    "order": 20,
    "requiresKnowledge": ["survived_dawnmere_attack"],
    "dialogueId": "spirit_scene_dawnmere_held"
  },
  {
    "id": "first_faction_meeting",
    "title": "The First Court",
    "order": 30,
    "requiresKnowledge": ["met_a_faction"],
    "dialogueId": "spirit_scene_first_faction"
  },
  {
    "id": "first_enemy_orcs",
    "title": "On the Orcs",
    "order": 40,
    "requiresKnowledge": ["encountered_faction_orcs"],
    "dialogueId": "spirit_scene_enemy_orcs"
  },
  {
    "id": "first_master_ability",
    "title": "On Mastery",
    "order": 50,
    "requiresKnowledge": ["mastered_an_ability"],
    "dialogueId": "spirit_scene_first_mastery"
  },
  {
    "id": "day_thirty",
    "title": "The Revelation of the Deadline",
    "order": 60,
    "requiresKnowledge": ["survived_day_30"],
    "dialogueId": "spirit_day30_reveal"
  },
  {
    "id": "ritual_first_omen",
    "title": "The Light Begins to Fail",
    "order": 65,
    "requiresKnowledge": ["saw_ritual_darkening"],
    "dialogueId": "spirit_scene_ritual_omen"
  },
  {
    "id": "first_anti_player_encounter",
    "title": "The Other Who Remembers",
    "order": 70,
    "requiresKnowledge": ["met_anti_player"],
    "dialogueId": "spirit_scene_anti_player_met"
  },
  {
    "id": "first_enemy_dragons",
    "title": "On Dragons",
    "order": 80,
    "requiresKnowledge": ["encountered_faction_dragons"],
    "dialogueId": "spirit_scene_enemy_dragons"
  },
  {
    "id": "first_enemy_trolls",
    "title": "On Trolls",
    "order": 81,
    "requiresKnowledge": ["encountered_faction_trolls"],
    "dialogueId": "spirit_scene_enemy_trolls"
  },
  {
    "id": "first_enemy_dark_elves",
    "title": "On the Dark Elves",
    "order": 82,
    "requiresKnowledge": ["encountered_faction_dark_elves"],
    "dialogueId": "spirit_scene_enemy_dark_elves"
  },
  {
    "id": "first_enemy_undead",
    "title": "On the Dead",
    "order": 83,
    "requiresKnowledge": ["encountered_faction_undead"],
    "dialogueId": "spirit_scene_enemy_undead"
  },
  {
    "id": "first_enemy_giants",
    "title": "On Giants",
    "order": 84,
    "requiresKnowledge": ["encountered_faction_giants"],
    "dialogueId": "spirit_scene_enemy_giants"
  },
  {
    "id": "first_enemy_demons",
    "title": "On What Comes Through the Tear",
    "order": 85,
    "requiresKnowledge": ["encountered_faction_demon_spirits"],
    "dialogueId": "spirit_scene_enemy_demons"
  },
  {
    "id": "first_faction_subjection",
    "title": "The First Realm to Kneel",
    "order": 90,
    "requiresKnowledge": ["subjected_a_faction"],
    "dialogueId": "spirit_scene_first_subjection"
  },
  {
    "id": "anti_player_identity",
    "title": "A Name for the Grey Man",
    "order": 100,
    "requiresKnowledge": ["anti_player_identity_known"],
    "dialogueId": "spirit_scene_anti_player_identity"
  },
  {
    "id": "first_anti_player_defeat",
    "title": "Beating Him Changes Nothing",
    "order": 110,
    "requiresKnowledge": ["defeated_anti_player"],
    "dialogueId": "spirit_scene_anti_player_defeated"
  },
  {
    "id": "anti_player_neutralized",
    "title": "The Severance",
    "order": 120,
    "requiresKnowledge": ["anti_player_neutralized"],
    "dialogueId": "spirit_scene_anti_player_severed"
  },
  {
    "id": "ebon_citadel_arrival",
    "title": "Beneath the Ebon Citadel",
    "order": 130,
    "requiresKnowledge": ["reached_ebon_citadel"],
    "dialogueId": "spirit_scene_ebon_citadel"
  },
  {
    "id": "ebon_citadel_breached",
    "title": "The Door That Is Not the Gate",
    "order": 135,
    "requiresKnowledge": ["breached_ebon_citadel"],
    "dialogueId": "spirit_scene_citadel_breached"
  }
]
